import { Button, Drawer, DrawerBody, DrawerContent, DrawerOverlay, VStack } from "@chakra-ui/react";

import { EnglishLabels } from "src/common/constants/englishLabels";
import { NavMenu } from "./homeNavbar";
import { RootState } from "src/store/store";
import { memo } from "react";
import { useSelector } from "react-redux";

type SideDrawerProps = {
    sideDrawerOpen: boolean;
    onClose: () => void;
    menu: NavMenu[]
    activeSection: string;
    handleNavClick: (nav: NavMenu) => void
}

const SideDrawer = memo(
    ({ sideDrawerOpen, onClose, menu, activeSection, handleNavClick }: SideDrawerProps) => {

  const globalLanguage = useSelector(
    (state: RootState) => state.globalInfo.globalLanguage
  );

  const isHindiLabels = globalLanguage === "HI";

    return (
        <Drawer onClose={onClose} isOpen={sideDrawerOpen} size="full">
            <DrawerOverlay 
                top="5rem"
            />
            <DrawerContent
                marginTop="calc(5rem - 1px)"
                background={"#FFFFFF"}
            >
                <DrawerBody>
                    <VStack
                        height="50%"
                        justifyContent="space-between"
                    >
                        {menu.map((nav) => {
                            const isJoinUsButton = nav.name === EnglishLabels.Join_us;
                            return (
                                <Button
                                    key={nav.name}
                                    className={`navbar-buttons ${isJoinUsButton ? "navbar-button-join-us" : ""}`}
                                    backgroundColor={nav.name === activeSection ? "#4A2C2A" : "white"}
                                    color={nav.name === activeSection ? "white" : "#4A2C2A"}
                                    onClick={() => handleNavClick(nav)}
                                    fontWeight={500}
                                    _hover={{
                                        backgroundColor: nav.name === activeSection ? "#4A2C2A" : "white",
                                        color: nav.name === activeSection ? "white" : "#4A2C2A",
                                        transform: 'scale(1.05)',
                                        transition:"transform 0.3s ease, opacity 0.3s ease"
                                    }}
                                    _active={{
                                        backgroundColor: nav.name === activeSection ? "#4A2C2A" : "white",
                                        color: nav.name === activeSection ? "white" : "#4A2C2A",
                                    }}
                                >
                                    {isHindiLabels ? nav.hindi : nav.name}
                                    {isJoinUsButton && <span className="blinking-dot" />}
                                </Button>
                            );
                        })}
                    </VStack>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
);

export default SideDrawer;
